import { KUDOS_SUPPORT_EMAIL } from '@globals/constants/supportEmail.const'
import { mobileQuery } from '@globals/themes/themeConstants'
import Button from '@mui/material/Button'
import { SxProps } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useCopyToClipboard } from '@shared/hooks/useCopyToClipboard'
import openLinkInNewTab from '@shared/utils/openLinkInNewTab'

const buttonStyle: SxProps = {
  mt: '0 !important',
  mb: '2px',
  [mobileQuery]: {
    mt: '0 !important',
  },
}

type MailToButtonProps = {
  text?: React.ReactNode
  startIcon?: React.ReactNode
}

export const useMailToAction = () => {
  const copyToClipboard = useCopyToClipboard()

  const handleClick = () => {
    copyToClipboard(KUDOS_SUPPORT_EMAIL)
    openLinkInNewTab(`mailto:${KUDOS_SUPPORT_EMAIL}`)
  }

  return {
    handleClick,
  }
}

const MailToButton: React.FC<MailToButtonProps> = ({ text, startIcon }) => {
  const { handleClick } = useMailToAction()
  return (
    <Button id="btnSupportEmail" sx={buttonStyle} onClick={handleClick} startIcon={startIcon}>
      <Typography variant="inherit">{text || ''}</Typography>
    </Button>
  )
}

export default MailToButton
